import React, { useState, createContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getUserStatus, login, logout } from "utils/apiRequests";
import { useTranslation } from "react-i18next";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const { t } = useTranslation();
  const [userAuthenticated, setUserAuthentication] = useState(false);
  const [userRoles, setUserRoles] = useState([]);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const handleLogin = async (data) => {
    try {
      const response = await login(data);
      if (response.status === 200) {
        const json = await response.json();
        setUserRoles(json.user.messageRoles.map((role) => role.name));
        setUser(json.user);
        setUserAuthentication(true);
        return { success: true };
      } else if (response.status === 401) {
        return { success: false, message: t("invalidUsernameOrPassword") };
      } else {
        return { success: false, message: t("loginFailedPleasetryAgain") };
      }
    } catch (error) {
      return { success: false, message: t("networkErrorPleaseTryAgainLater") };
    }
  };  

  const handleLogout = async () => {
    try {
      const response = await logout();
      if (response.status === 200) {
        setUserAuthentication(false);
        navigate("/");
      } else {
        console.error("Error logging out");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };

  const verifyAuth = async () => {
    try {
      const response = await getUserStatus();
      if (response.status === 200) {
        const json = await response.json();
        setUserRoles(json.user.messageRoles.map((role) => role.name));
        setUser(json.user);
        setUserAuthentication(true);
      } else {
        setUserAuthentication(false);
      }
    } catch (error) {
      console.error("Error while verifying user:", error);
      setUserAuthentication(false);
    }
  };

  useEffect(() => {
    const checkAuth = async () => {
      await verifyAuth();
    };
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        handleLogin,
        handleLogout,
        userAuthenticated,
        userRoles,
        user
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
